export default __webpack_public_path__ + "static/media/reliability.739e5d28.svg";